<template>
  <popup-modal ref="popup">
    <div class="d-flex justify-center">
      <h2 class="font-weight-bold">
        {{ title }}
      </h2>
    </div>
    <div class="my-8">
      <p>
        {{ message }}
      </p>
    </div>
    <div class="my-8">
      <v-autocomplete
        id="select"
        v-model="selected"
        :items="arrayList"
        item-title="name"
        item-value="technical_id"
        return-object
        required
      >
        <template v-slot:selection="{ item, index }">
          <v-chip size="small" v-if="index < 1">
            <span>{{ item.title }}</span>
          </v-chip>
          <span v-if="index === 1" class="text-grey text-caption align-self-center">
            (+{{ selected.length - 1 }}
            {{ selected.length - 1 === 1 ? $t('COMMON.TABLE.OTHER') : $t('COMMON.TABLE.OTHERS') }})
          </span>
        </template>
        <template v-slot:item="{ item, props }">
          <v-list-item :title="item.title" :value="item.value" v-bind="props">
            <v-tooltip
              v-if="shouldShowTooltip(item, 'select')"
              activator="parent"
              location="bottom left"
            >
              {{ item.title }}
            </v-tooltip>
          </v-list-item>
        </template>
      </v-autocomplete>
    </div>

    <div class="d-flex justify-center">
      <v-btn
        :disabled="!selected"
        class="boom-button dialog-button"
        variant="outlined"
        @click="_confirm"
      >
        {{ validateButton }}
      </v-btn>
    </div>
  </popup-modal>
</template>

<script>
import { shouldShowTooltip } from '@/components/utils/globalFunction'
import PopupModal from '@/components/modal/PopupModal.vue'

export default {
  name: 'SelectStoreModal',
  components: { PopupModal },
  data: () => ({
    selected: null,
    arrayList: [],

    title: undefined,
    message: undefined,
    placeholder: undefined,
    validateButton: undefined,

    resolvePromise: undefined,
    rejectPromise: undefined
  }),
  methods: {
    shouldShowTooltip,
    show(opts = {}) {
      this.title = opts.title
      this.message = opts.message
      this.arrayList = opts.arrayList
      this.placeholder = opts.placeholder
      this.validateButton = opts.validateButton
      this.$refs.popup.open()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    _confirm() {
      this.$refs.popup.close()
      this.resolvePromise({
        confirmed: true,
        selection: this.selected
      })
    }
  }
}
</script>
<style scoped>
.dialog-button {
  min-width: 200px;
}
</style>
